import { Tooltip } from '@fluentui/react-components';
import type { ReadinessState } from '@vigeo/shared';
import { StatusDot, complianceTokenFor } from '@vigeo/ui';
import { statePresenters } from './presenters.js';

export interface ReadinessBadgeProps {
  readonly state: ReadinessState;
}

/**
 * The one place a readiness state is rendered.
 *
 * Colour comes from the presenter registry, so the pipeline badge and the checklist header
 * cannot disagree — and a new state fails the build in presenters.ts rather than rendering
 * as an unstyled chip here.
 */
export function ReadinessBadge({ state }: ReadinessBadgeProps) {
  const presenter = statePresenters[state];

  return (
    <Tooltip content={presenter.meaning} relationship="description" withArrow>
      <span>
        <StatusDot color={complianceTokenFor[presenter.tone]}>{presenter.label}</StatusDot>
      </span>
    </Tooltip>
  );
}
